import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyBuWQCW_xtq0L74FrVwPmZ3EUf7sN1nfyY',
    key: 'AIzaSyA1u6V5E13D9H2RHOpSjOCIhpYkUcxlkUk',
    // key: 'AIzaSyAB1woc0JlHiA3qHM8o87dj4UUNDETLrcY',
    // key: "AIzaSyApkJD-vBesPqZOKxrlrQw9puH852wp1n4",
    // key: "AIzaSyAucQBbBd9rin3qGmzjXY2WZyd_mE6qxrk",
    libraries: 'places',
    region: 'ID',
    language: 'id'
  },
  installComponents: true
});

export default VueGoogleMaps;
